import {
	Box,
	Button,
	Flex,
	MenuList,
	MenuItem,
	Spinner,
	Badge,
	Text,
} from '@chakra-ui/react';
import NotificationBox from './NotificationBox';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useMarkAllRead } from 'hooks/notification/useMarkAllRead';

// const NotificationDropDown = ({
// 	unreadCount,
// 	loading,
// 	notificationList,
// 	loadMoreNotifications,
// 	hideLoadMoreBtn,
// 	notificationCount,
// 	hasMore,
// }) => {
// 	const users = useSelector((state) => state.user.users);

// 	return (
// 		<>
// 			<MenuList
// 				w={{ base: '90vw', sm: '80vw', md: '350px', lg: '400px' }}
// 				minW={{ base: '250px', sm: '280px' }}
// 				maxH={{ base: '60vh', md: '450px' }}
// 				overflowY='auto'
// 				sx={{
// 					'&::-webkit-scrollbar': {
// 						width: '8px',
// 						transition: 'opacity 0.3s',
// 					},
// 					'&:hover::-webkit-scrollbar': {
// 						opacity: 1,
// 					},
// 					'&::-webkit-scrollbar-thumb': {
// 						backgroundColor: 'bg.elevated',
// 						borderRadius: '4px',
// 					},
// 					'&::-webkit-scrollbar-thumb:hover': {
// 						backgroundColor: 'gray.300',
// 					},
// 				}}
// 			>
// 				{/* Header */}
// 				<Box
// 					fontWeight='bold'
// 					// bg='brand.500'
// 					color='gold.400'
// 					p={2}
// 					borderBottom='1px solid'
// 					borderColor='gold.400'
// 					fontSize={{ base: 'md', md: 'lg' }}
// 				>
// 					Notifications
// 				</Box>

// 				{/* Notification List */}
// 				<Box px={{ base: 1, md: 0 }}>
// 					{notificationList.length > 0 ? (
// 						<Flex direction='column' gap={{ base: '1', md: '2' }}>
// 							{notificationList.map((item) => {
// 								if (!item?.notification) return null;

// 								return (
// 									<MenuItem
// 										key={item._id || item.notification?._id}
// 										rounded='md'
// 										p={{ base: 2, md: 2 }}
// 										_hover={{ bg: 'bg.subtle' }}
// 										_focus={{ bg: 'bg.subtle' }}
// 									>
// 										<NotificationBox
// 											data={item}
// 											users={users}
// 											fontSize={{ base: 'sm', md: 'md' }}
// 										/>
// 									</MenuItem>
// 								);
// 							})}
// 						</Flex>
// 					) : (
// 						<Text
// 							color='text.secondary'
// 							textAlign='center'
// 							py={{ base: 4, md: 6 }}
// 							fontSize={{ base: 'sm', md: 'md' }}
// 						>
// 							No notifications
// 						</Text>
// 					)}
// 				</Box>

// 				{/* Footer */}
// 				<Box
// 					p={{ base: 2, md: 3 }}
// 					textAlign='center'
// 					borderTop='1px solid'
// 					borderColor='border.default'
// 				>
// 					{loading ? (
// 						<Spinner color='brand.400' />
// 					) : (
// 						hasMore && (
// 							<Button
// 								size='sm'
// 								colorScheme='gray'
// 								onClick={loadMoreNotifications}
// 							>
// 								Load More
// 							</Button>
// 						)
// 					)}
// 				</Box>
// 			</MenuList>
// 		</>
// 	);
// };

// export default NotificationDropDown;

const NotificationDropDown = ({
	unreadCount,
	loading,
	notificationList,
	loadMoreNotifications,
	hasMore,
}) => {
	const users = useSelector((state) => state.user.users);
	const { markAllRead, isMarking } = useMarkAllRead();

	const handleMarkAllRead = async () => {
		try {
			await markAllRead();
		} catch {
			toast.error('Could not mark notifications as read.');
		}
	};

	return (
		<MenuList
			// border='1px solid'
			// borderColor='brand.400'
			borderRadius='20px'
			bg='bg.surface'
			boxShadow='card'
			p='0'
			overflow='hidden'
			w={{ base: '95vw', sm: '380px', md: '420px' }}
			maxW='420px'
			maxH='75vh'
			zIndex={999}
		>
			{/* HEADER */}
			<Flex
				align='center'
				justify='space-between'
				px={5}
				py={4}
				borderBottom='1px solid'
				borderColor='border.subtle'
				bg='rgba(255, 149, 0, 0.03)'
				backdropFilter='blur(12px)'
				position='sticky'
				top='0'
				zIndex='1'
			>
				<Box>
					<Text
						fontSize='lg'
						fontWeight='bold'
						color='text.heading'
						letterSpacing='tight'
					>
						Notifications
					</Text>

					<Text fontSize='xs' color='text.muted' mt='0.5'>
						{unreadCount || 0} unread notifications
					</Text>
				</Box>

				{unreadCount > 0 && (
					<Flex align='center' gap={2}>
						<Button
							size='xs'
							variant='ghost'
							color='text.accent'
							fontWeight='semibold'
							onClick={handleMarkAllRead}
							isLoading={isMarking}
							_hover={{ bg: 'accent.subtle' }}
						>
							Mark all as read
						</Button>
						<Badge
							variant='gold'
							px={2.5}
							py={1}
							fontSize='11px'
							borderRadius='full'
						>
							{unreadCount}
						</Badge>
					</Flex>
				)}
			</Flex>

			{/* NOTIFICATIONS */}
			<Box
				maxH='calc(75vh - 140px)'
				overflowY='auto'
				sx={{
					'&::-webkit-scrollbar': {
						width: '6px',
					},
					'&::-webkit-scrollbar-track': {
						background: 'transparent',
					},
					'&::-webkit-scrollbar-thumb': {
						background: 'var(--chakra-colors-bg-elevated)',
						borderRadius: '10px',
					},
					'&::-webkit-scrollbar-thumb:hover': {
						background: 'var(--chakra-colors-bg-input)',
					},
				}}
			>
				{notificationList?.length > 0 ? (
					<Flex direction='column' p={2} gap={2}>
						{notificationList.map((item, index) => {
							if (!item?.notification) return null;

							// NotificationBox renders its own per-type coloured card
							// (accent rail, tint, icon chip, unread dot).
							return (
								<NotificationBox
									key={item?._id || item?.notification?._id || index}
									data={item}
									users={users}
								/>
							);
						})}
					</Flex>
				) : (
					<Flex
						direction='column'
						align='center'
						justify='center'
						py={14}
						px={6}
						textAlign='center'
					>
						<Box
							w='70px'
							h='70px'
							borderRadius='full'
							bg='rgba(255, 149, 0, 0.08)'
							display='flex'
							alignItems='center'
							justifyContent='center'
							mb={4}
							fontSize='28px'
						>
							🔔
						</Box>

						<Text fontSize='md' fontWeight='semibold' color='text.heading'>
							No notifications yet
						</Text>

						<Text
							fontSize='sm'
							color='text.muted'
							mt={1}
							maxW='240px'
							lineHeight='1.6'
						>
							New updates, activities, and alerts will appear here.
						</Text>
					</Flex>
				)}
			</Box>

			{/* FOOTER */}
			<Box
				borderTop='1px solid'
				borderColor='border.subtle'
				p={3}
				bg='rgba(255,255,255,0.01)'
				backdropFilter='blur(10px)'
			>
				{loading ? (
					<Flex align='center' justify='center' py={2}>
						<Spinner
							thickness='3px'
							speed='0.65s'
							emptyColor='border.default'
							color='gold.primary'
							size='md'
						/>
					</Flex>
				) : (
					hasMore && (
						<Button
							w='100%'
							variant='outline'
							size='sm'
							onClick={loadMoreNotifications}
							fontWeight='semibold'
							_hover={{
								bg: 'rgba(255, 149, 0, 0.08)',
							}}
						>
							Load More Notifications
						</Button>
					)
				)}
			</Box>
		</MenuList>
	);
};

export default NotificationDropDown;
